import React from 'react';

import { connect } from 'react-redux';
import { toggleAccountInfo } from "../state/actions/app"

const mapStateAsProps = state => ({
	user: state.setUser.user,
	titleState: state.projectInfo.titleState,
	info: state.projectInfo
})

const mapDispatchAsProps = dispatch => ({
	toggleAccountInfo: () => dispatch(toggleAccountInfo())
})
const logout = () => {
	window.auth.lock.logout(()=>window.location.reload());
}


const Navbar = ({ user, toggleAccountInfo }) => {
	const userInfo = {}
	let isUserDefault = true
	if (user) {
		userInfo.name = window.getName(user)
		userInfo.email = user.email
		userInfo.splitName = userInfo.name.split(" ")
		userInfo.initials = userInfo.splitName.length > 1 ? userInfo.splitName[0][0]+userInfo.splitName[1][0] : userInfo.name.slice(0,2)

		userInfo.accountName = user.account.name
		userInfo.accountEmail = user.account.email
		userInfo.plan = window.capitalize(user.account.bundle.name)
		isUserDefault = user.account.default
	}

	return (
		<React.Fragment>
			
			<div className="navbar navbar-default navbar-static-top navbar-main dashboard">
				<div>
					<div className="navbar-header">
						<div className="navbar-brand-title">
							<a className="navbar-brand brand-name logo" href="/dashboard">
								<img src="/images/brand/meterian_logo_white.svg" />
							</a><i className="fas fa-flask" id="experimental-mode" title="Experimental mode"></i>
							<div className="navbar-cobrand navbar-cobrand-divider"></div>
							<div className="navbar-cobrand">
								<div className="logo">
									<img src="/images/brand/co-brand.png" />
								</div>
							</div>
						</div>

					</div>
					{
						user && !isUserDefault?
						<div className="navbar-menu-right" onClick={toggleAccountInfo}>
							<div id="header-info" className="hide-at-loading">
								<div className="account-details">
									<span id="user-info" ><span id="logged-name">{userInfo.name}</span></span>
									<span id="account-info" ><span id="head-email">{userInfo.email}</span></span>
								</div>
								<div className="hidden visible-sm visible-md visible-lg visible-xl">
									<div className="account-avatar" 
											data-name={userInfo.name}
											data-email={userInfo.email}	
											data-account-name={userInfo.accountName}
											data-account-email={userInfo.accountEmail}
											data-plan={userInfo.plan}
										><span className="account-initials">{userInfo.initials.toUpperCase()}</span></div>
								</div>
							</div>
						</div> :
						null

					}

					<button className="navbar-toggler" type="button" data-toggle="collapse" 
						data-target="#navbar-ex-collapse" aria-controls="navbar-ex-collapse" 
						aria-expanded="false" aria-label="Toggle navigation">
    					<i className="fas fa-bars"></i>
  					</button>

				</div>
				<div className="collapse navbar-collapse navbar-backyard" id="navbar-ex-collapse">
					<ul className="nav navbar-nav">
						<li>
							<a href="/">Home</a>
						</li>
						<li className="hidden-sm">
							<a href="https://blog.meterian.com" target="_blank" rel="noopener noreferrer">Blog</a>
						</li>
						<li className="hidden-sm meterian-only">
							<a href="/plans#faq" target="_blank" rel="noopener noreferrer">FAQ</a>
						</li>
						<li>
							<a href="/status" target="_blank" rel="noopener noreferrer">Status</a>
						</li>
						<li>
							<a href="https://docs.meterian.io" target="_blank" rel="noopener noreferrer">Docs</a>
						</li>
						<li>
							<a href="/api" target="_blank" rel="noopener noreferrer">API</a>
						</li>
						{ user && !isUserDefault? 
							<li className="login-link ">
								<a onClick={logout} className="logout-button" href="#">Logout</a>
							</li>
							:
							null
						}
					</ul>

				</div>
			</div>
			<div className="navbar navbar-default navbar-static-top navbar-secondary navbar-secondary-white">
				<div>

					<div className="navbar-offset"></div>
					<div className="navbar-menu">
						<div className="navbar-menu-decoration"></div>
						<ul className="nav navbar-nav">
							<li>
								<a href="/">Home</a>
							</li>
							<li className="hidden-sm">
								<a href="https://blog.meterian.com" target="_blank" rel="noopener noreferrer">Blog</a>
							</li>
							<li className="hidden-sm meterian-only">
								<a href="/plans#faq" target="_blank" rel="noopener noreferrer">FAQ</a>
							</li>
							<li>
								<a href="/status" target="_blank" rel="noopener noreferrer">Status</a>
							</li>
							<li>
								<a href="https://docs.meterian.io" target="_blank" rel="noopener noreferrer">Docs</a>
							</li>
							<li>
								<a href="/api" target="_blank" rel="noopener noreferrer">API</a>
							</li>
							{ user && !isUserDefault? 
								<li className="login-link ">
									<a onClick={logout} className="logout-button" href="#">Logout</a>
								</li>
								:
								null
							}
						</ul>

					</div>
				</div>
			</div>
		</React.Fragment>

	)
}

export default connect(mapStateAsProps, mapDispatchAsProps)(Navbar);